import config from '../../config'

const jweixin = require('./index')

/**
 * 配置微信 JS-SDK
 * 签名 URL 必须与当前页面 URL（去掉 hash 后的部分）一致，微信才会校验通过
 * @param {Function} callback 配置成功后的回调，回调参数为 jweixin 对象
 * @param {String} url 参与签名的页面 URL，缺省取当前页面
 */
const configWeiXin = async function(callback, url) {
	let signUrl = url || (typeof window !== 'undefined' && window.location ? window.location.href.split('#')[0] : '')
	uni.request({
		url: config.baseUrl + '/common/wechat/jssdk',
		data: {
			url: signUrl
		},
		method: 'get',
		success: (res) => {
			if (res.statusCode === 200) {
				const resConfig = res.data
				if (resConfig) {
					const apiList = [ // 可能需要用到的能力
						'chooseWXPay',
						'updateAppMessageShareData',
						'updateTimelineShareData'
					]
					const info = {
						debug: config.debug, // 调试，发布的时候改为false
						appId: resConfig.appId,
						nonceStr: resConfig.nonceStr,
						timestamp: resConfig.timeStamp,
						signature: resConfig.signature,
						jsApiList: apiList
					}
					jweixin.config(info)
					jweixin.error(err => {
						console.log('config fail:', err)
					})

					jweixin.ready(res => {
						if (callback) callback(jweixin) // 配置成功
					})
				}
			}
		}
	})
}

export {
	configWeiXin
}
